import { Link } from 'react-router-dom';
import { Coffee } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-border px-5 py-4">
      <div className="flex items-center justify-center gap-4 flex-wrap">
        <div className="flex items-center gap-1.5 text-muted-foreground">
          <Coffee size={13} strokeWidth={1.5} />
          <span className="text-xs">Signature Coffee Note</span>
        </div>
        <Link to="/privacy" className="text-xs text-muted-foreground hover:text-primary transition-colors">
          Privacy Policy
        </Link>
        <Link to="/terms" className="text-xs text-muted-foreground hover:text-primary transition-colors">
          Terms of Service
        </Link>
        <Link to="/contact" className="text-xs text-muted-foreground hover:text-primary transition-colors">
          Contact
        </Link>
      </div>
    </footer>
  );
}